import type { WalletAccount } from '@dynamic-labs-sdk/client';

import type { TronWalletAccount } from '../TronWalletAccount.types';

export const isTronWalletAccount = (
  walletAccount: WalletAccount
): walletAccount is TronWalletAccount => walletAccount.chain === 'TRON';
